import { useEffect } from 'react'
import { Button, Typography } from 'mobily-ui-library/lib';
import Close from '../../assets/Close.svg';

import './InfoModal.scss';
import { useTranslation } from 'react-i18next';

interface Props {
    id: string;
    rtl: boolean;
    modalFirstButtonClick?: () => void;
    data: any;
}

function InfoModal({ rtl, id, modalFirstButtonClick, data }: Props) {
    const { t } = useTranslation();

    useEffect(() => {
        document.body.style.overflow = 'hidden';
    }, []);

    return (
        <div className={rtl ? 'Info__ModalContainer Info__ModalRight' : 'Info__ModalContainer'}>
            <div className='CC__Fallback'></div>
            <div className='CC__Modal h-auto' id={id}>
                <div className='CC__ModalContent'>
                    <div className='CC__header' onClick={modalFirstButtonClick}>
                        <div></div>
                        <img src={Close} alt='Close' className='CC__Close' />
                    </div>
                    <Typography rtl={rtl} className='CC__MSTitle mb-1'>{t('Request_Have_Covered_Fiber')} </Typography>
                    <div className='mb-3 text-left p-3'>
                        <div className='d-flex'>
                            <Typography rtl={rtl} className='CC__MST mb-1 text-left col-3'>{t('ODB_Number')} </Typography>:
                            <div className='col-9 CC__DV'>{data.ODB}</div>
                        </div>
                        <div className='d-flex'>
                            <Typography rtl={rtl} className='CC__MST mb-1 text-left col-3'>{t('Package_Link')} </Typography>:
                            <div className='fiber-package-link'>
                                <a href="https://www.mobily.com.sa/web/en/personal/home/fiber-postpaid/fiber-postpaid">
                                    https://www.mobily.com.sa/web/en/personal/home/fiber-postpaid/fiber-postpaid
                                </a>
                            </div>
                        </div>
                    </div>
                    <Typography rtl={rtl} className='CC__MSTitle mb-4'>{t('More_Details_Check_Link')} </Typography>
                    <Button rtl={rtl} className='CC__MButton' onClick={modalFirstButtonClick}>{t('Got_it')}</Button>
                </div>

            </div>
        </div>
    )
}

export default InfoModal